module.exports = __webpack_public_path__ + "media/images/who-we-are-2ffd17cc63f36a9627d9bfed73f09ee8.jpg";